import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ResponseMission } from '../../../../services/api/models/response/responseMission';

export interface LiveMissionState {
  isShowConfirmModal: boolean;
  listMissionConfirm: ResponseMission[];
}
const initState: LiveMissionState = {
  isShowConfirmModal: false,
  listMissionConfirm: [],
};

const LiveMissionSlice = createSlice({
  name: 'live-mission',
  initialState: initState,
  reducers: {
    toggleConfirmGiftMissionModal: (state, action: PayloadAction<boolean>) => {
      state.isShowConfirmModal = action.payload;
    },
    updateListMissionConfirm: (
      state,
      action: PayloadAction<ResponseMission[]>,
    ) => {
      state.listMissionConfirm = action.payload;
    },
  },
});
export const { toggleConfirmGiftMissionModal, updateListMissionConfirm } =
  LiveMissionSlice.actions;
export const LiveMissionReducer = LiveMissionSlice.reducer;
